import { Component, OnInit } from "@angular/core";
import moment from "moment";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { UserService } from "src/app/core/services/user.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { CustomerVenueGroup } from "src/app/shared/models/CustomerVenueGroup.item";
import { MarketingBlastStatus } from "src/app/shared/models/enums/marketing-blast-status.enum";
import { MarketingBlast } from "src/app/shared/models/MarketingBlast.item";
import { MarketingTemplate } from "src/app/shared/models/MarketingTemplate.item";
import * as uuid from "uuid";

@Component({
	selector: "app-blasts",
	templateUrl: "./blasts.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class BlastsComponent implements OnInit {
	blastList: MarketingBlast[];
	blastListFiltered: MarketingBlast[];
	blastSelected: MarketingBlast;
	customerGroupList: CustomerVenueGroup[];

	moment: any = moment;
	newBlast: boolean = false;

	showArchived: boolean = false;

	templateList: MarketingTemplate[];

	constructor(public app: AppService, private focuslink: FocuslinkService, public venueService: OOVenueService, public userService: UserService) {}

	ngOnInit(): void {
		this.init();
	}

	async init() {
		this.templateGet();
		this.blastGet();
		this.groupGet();
	}

	async load() {
		this.templateGet();
		this.blastGet();
		this.groupGet();
		this.app.loading(false);
	}

	async templateGet() {
		const resp = await this.focuslink.marketingTemplateGetAll(this.venueService.subscriptionVenue.value.key);
		this.templateList = resp.map((i) => new MarketingTemplate(i));
	}

	async blastGet() {
		const resp = await this.focuslink.marketingBlastGetAll(this.venueService.subscriptionVenue.value.key);
		this.blastList = resp.map((i) => {
			const b = new MarketingBlast(i);
			b.blastStatusString = this.blastStatus(b.status);
			return b;
		});
		this.blastList.sort((a, b) => moment(a.createdDate).unix() - moment(b.createdDate).unix());
		this.blastListRefresh();
	}

	async groupGet() {
		const resp = await this.focuslink.customerGroupsGet(this.venueService.subscriptionVenue.value.key);
		const updateGroupResults: string[] = [];
		this.customerGroupList = resp.map((i) => new CustomerVenueGroup(i));
	}

	blastNew() {
		this.blastSelected = new MarketingBlast({
			pk: this.venueService.subscriptionVenue.value.key.toString(),
			sk: uuid.v4(),
			createdDate: moment().format(),
		});
		this.newBlast = true;
	}

	blastListRefresh() {
		if (this.showArchived) {
			this.blastListFiltered = [...this.blastList];
		} else {
			this.blastListFiltered = [...this.blastList.filter((i) => i.status !== MarketingBlastStatus.ARCHIVED)];
		}
	}

	blastStatus(status: number): string {
		switch (status) {
			case MarketingBlastStatus.DELETED:
				return "Deleted";
			case MarketingBlastStatus.ERROR:
				return "Errored";
			case MarketingBlastStatus.PENDINGSEND:
				return "Sending...";
			case MarketingBlastStatus.SCHEDULED:
				return "Scheduled";
			case MarketingBlastStatus.SENT:
				return "Sent";
			case MarketingBlastStatus.UNSCHEDULED:
				return "Pending";
			default:
				return "Shrug?";
		}
	}

	blastSaveFromNew(blast: MarketingBlast) {
		console.log(blast);
		this.blastSelected = undefined;
		const existIdx = this.blastList.findIndex((i) => i.sk === blast.sk);
		if (existIdx !== -1) {
			this.blastList[existIdx] = blast;
		} else {
			this.blastList.push(blast);
		}
		this.blastListRefresh();
	}

	blastDeleteFromNew(sk: string) {
		const idx = this.blastList.findIndex((i) => i.sk === sk);
		console.log(idx);
		if (idx !== -1) {
			this.blastList.splice(idx, 1);
		}
		this.blastListRefresh();
	}

	blastChangeStatus(blast: MarketingBlast, newStatus: number) {
		blast.status = newStatus;
		this.focuslink.marketingBlastPatch(this.venueService.subscriptionVenue.value.key, blast);
		this.blastList[this.blastList.findIndex((i) => i.sk === blast.sk)] = blast;
		this.blastListRefresh();
	}

	blastStopSend(blast: MarketingBlast) {
		this.app.confirmation.confirm({
			message: `Pause sending the ${blast.name} Blast?`,
			accept: async () => {
				this.blastChangeStatus(blast, MarketingBlastStatus.UNSCHEDULED);
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}

	blastRestartSend(blast: MarketingBlast) {
		let sendMessage: string;
		if (moment(blast.sendDate).isSameOrBefore(moment())) {
			sendMessage = `This Blast was originally scheduled for ${moment(blast.sendDate).format(
				"l LT"
			)}, this action will send the Blast immediately. Proceed?`;
		} else {
			sendMessage = `This Blast will send on ${moment(blast.sendDate).format("l LT")}. Proceed?`;
		}
		this.app.confirmation.confirm({
			message: `${sendMessage}`,
			accept: async () => {
				this.blastChangeStatus(blast, MarketingBlastStatus.SCHEDULED);
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}
}
